import { z } from "zod";

export const orgSlugParamsSchema = z.object({
	org: z
		.string()
		.min(1)
		.max(64)
		.regex(/^[a-z0-9-]+$/i),
	slug: z
		.string()
		.min(1)
		.max(128)
		.regex(/^[a-z0-9-]+$/i),
});

export type OrgSlugParams = z.infer<typeof orgSlugParamsSchema>;

// Minimal portal config shape for editing/preview
export const PortalConfigSchema = z
	.object({
		title: z.string().min(1).default("New Portal"),
		theme: z
			.object({ mode: z.string().optional(), accent: z.string().optional() })
			.optional(),
		blocks: z.array(z.any()).default([]),
	})
	.passthrough();

export type PortalConfig = z.infer<typeof PortalConfigSchema>;
